/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */

import { FC, useState } from 'react';
import { BundleUpchargePriceDeviationDrawerProps } from '@/pages/Franchisee/Bundles/BundleUpcharges/components/PriceDeviation/BundleUpchargePriceDeviationDrawerProps.types';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import styles from './BundleUpchargePriceDeviationDrawer.module.css';
import { X } from 'react-feather';
import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';
import { useBundleUpchargePriceDeviations } from '@/services/bundles/bundles.service';
import { BundleUpchargePriceDeviationDrawerTable } from '@/pages/Franchisee/Bundles/BundleUpcharges/components/PriceDeviation/BundleUpchargePriceDeviationDrawerTable';

export const BundleUpchargesPriceDeviationDrawer: FC<BundleUpchargePriceDeviationDrawerProps> = ({
  isOpen,
  onClose,
  cameFromEditDrawer,
  type,
  groupId,
}) => {
  const [state, setState] = useState(isOpen);
  const { t } = useTranslation();
  const { data: priceDeviations = [] } = useBundleUpchargePriceDeviations(true, type, groupId);

  return (
    <div>
      <SwipeableDrawer open={isOpen} onClose={onClose} onOpen={() => {}} anchor="bottom">
        <div className={styles.container}>
          <header>
            <div>
              <h1>{t('priceDeviations.priceDeviations')}</h1>
            </div>
            <button type="button" onClick={onClose}>
              <X data-testid="x-icon" size={24} color="var(--black-900)" />
            </button>
          </header>
          <div className={styles.content}>
            {cameFromEditDrawer && (
              <Button
                variant={ButtonVariants.Text}
                className={styles.backLink}
                onClick={onClose}
                data-testid="backToEdit"
              >
                <ArrowBackIcon fontSize="large" />
                <div>Back to Edit</div>
              </Button>
            )}
            <div className={styles.selectedGroupName}>{priceDeviations.storeGroupName}</div>
            <BundleUpchargePriceDeviationDrawerTable data={priceDeviations} />
          </div>
        </div>
      </SwipeableDrawer>
    </div>
  );
};
export default BundleUpchargesPriceDeviationDrawer;
